import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import MyDropdownButton from "../Common/MyDropdownButton";
import { whatToPingOptions } from "./HowToMonitor";
import HelpButton from "../HelpContent/HelpButton";

export default function PingMethod({ method, setMethod }) {
  return (
    <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse px-5 mx-auto">
      <div className="mb-3">
        <span className="fs-4 fw-bold ">
          What would you like to ping?
          <HelpButton helpKey="ping-method" />
        </span>
      </div>

      <div className="mb-3">
        <Dropdown>
          <div className="d-flex">
            <Dropdown.Toggle
              id="dropdown-monitor-ping-method"
              className="bg-white text-black w-100 border-0 d-flex justify-content-between align-items-center text-start p-2 rounded-3"
            >
              {method ? (
                <MyDropdownButton
                  option={whatToPingOptions.find((o) => o.name === method)}
                />
              ) : (
                <div className="fw-bold text-start fs-5 ">Please select...</div>
              )}
            </Dropdown.Toggle>
          </div>

          <Dropdown.Menu className="bg-purple-gradient">
            {whatToPingOptions?.map((o) => (
              <Dropdown.Item key={o.name} href="#/action-1" className="border-bottom">
                <button
                  type="button"
                  className={`btn rounded-4 text-start`}
                  onClick={(e) => {
                    e.preventDefault();
                    setMethod(o.name);
                  }}
                >
                  <div className="d-flex w-100">
                    <MyDropdownButton option={o} />
                  </div>
                </button>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
